$(document).ready(function () {

  // $(document).on('click','.collection__filter--button',function(e) {
  //   e.preventDefault();
  //   $('.collection__filter--button').removeClass('active');
  //   $(this).addClass('active');
  //   $('.collage__collection--section').hide();
  //   var currentId = $(this).attr('href');
  //   var idArray = currentId.split('#');
  //   if (idArray[1]=="all-products") {
  //     $('.collage__collection--section').show();
  //   } else {
  //     $('#'+idArray[1]).show();
  //   }
  // });

  $(document).on('click','.product-info__filter--button',function(e) {
    e.preventDefault();
    $('.product-info__filter--button').removeClass('active');
    $(this).addClass('active');
    $('.product-info__item').hide();
    var currentId = $(this).attr('href');
    var idArray = currentId.split('#');
    $('.product-info__'+idArray[1]).show();
  });

  $(document).on('click','.benefits__tooltip',function(e) {
    e.preventDefault();
    var currentId = $(this).attr('href');
    var idArray = currentId.split('#benefits__tooltip--');
    $('.benefits__info').hide();
    $('.benefits__info--'+idArray[1]).show();
    $('.benefits__text--wrapper').addClass('blur');
    $('.benefits__image--wrapper').addClass('blur');
    $('.benefits__tooltip').hide();
  });

  $('.benefits__wrapper').click(function(e){
    if ($('.benefits__info:visible').length) {
      if($(e.target).closest('.benefits__info').length > 0) {
        return false;
      }
      $('.benefits__info').hide();
      $('.benefits__text--wrapper').removeClass('blur');
      $('.benefits__image--wrapper').removeClass('blur');
      $('.benefits__tooltip').show();
    }
  });

  $('.product-info__accordion--item, .faq__accordion--item').click(function() {
    if ($('.product-info__accordion--trigger, .faq__accordion--trigger', this).hasClass('active')) {
      $('.product-info__accordion--panel, .faq__accordion--panel', this).slideUp();
      $('.product-info__accordion--trigger, .faq__accordion--trigger').removeClass('active');
    } else {
      $('.product-info__accordion--trigger, .faq__accordion--trigger').removeClass('active');
      $('.product-info__accordion--panel, .faq__accordion--panel').slideUp();
      $('.product-info__accordion--trigger, .faq__accordion--trigger', this).addClass('active');
      $('.product-info__accordion--panel, .faq__accordion--panel', this).slideDown();
    }
  });

});